import { css } from 'styled-components';
import { getTypography, TypographyName } from '../../../theme';
export const wrapper = css(["position:relative;"]);
export const errorTooltip = _ref => {
  let {
    theme
  } = _ref;
  return css(["", " background:", ";border-radius:.3rem;box-shadow:0 0 .5rem rgba(0,0,0,0.2);color:", ";margin-top:1px;padding:0.5rem 1rem;position:absolute;pointer-events:none;z-index:", ";"], getTypography(theme, TypographyName.BODY), theme.palettes.status.alert, theme.palettes.neutrals.lightest, theme.zIndex.overthetop);
};
export const errorTooltipArrow = _ref2 => {
  let {
    theme
  } = _ref2;
  return css(["width:16px;height:14px;overflow:hidden;position:absolute;left:1rem;bottom:100%;&:after{content:\"\";position:absolute;top:8px;left:0;width:16px;height:16px;background:", ";box-shadow:6px 5px 9px -9px rgba(0,0,0,0.2);transform:rotate(45deg);}"], theme.palettes.status.alert);
};
//# sourceMappingURL=withField.style.js.map